export enum CancellationReason {
    TooExpensive = 1 << 0,
    AccuracyConcerns = 1 << 1,
    SwitchingPlatforms = 1 << 2,
    LackingFeatures = 1 << 3,
    CustomerSupportIssues = 1 << 4,
    NoLongerNeeded = 1 << 5,
    Other = 1 << 6,
}